const sleep = (ms) => new Promise((resolve) => {
    setTimeout(resolve, ms);
});

export const awaitAtLeast = async (ms, asyncFunction, ...asyncFunctionParameters) => {
    const start = new Date().getTime();

    const result = await asyncFunction(...asyncFunctionParameters);

    const diff = ms - (new Date().getTime() - start);

    // wait a bit if we havent waited long enough
    if (diff > 0) await sleep(diff);

    return result;
};

export const asyncRetryReturnThrown = async (times, ms, asyncFunction) => {
    let count = 0;
    let result;
    while (!result) {
        count += 1;
        try {
            result = await asyncFunction(); // eslint-disable-line no-await-in-loop
        } catch (error) {
            if (count === times) return error;
            console.log(error); // eslint-disable-line no-console
        }
        await sleep(ms); // eslint-disable-line no-await-in-loop
    }
    return result;
};
